module.exports = __webpack_public_path__ + "img/cir-done.db82cc0e.svg";